/**
 * <pre>
 * PrivacyManagement module.
 *
 * This module is responsible for all PrivacyManagement related logic.
 *
 * Summary of responsibilities:
 *
 *  - defines app interface
 * </pre>
 *
 * @module PrivacyManagement
 */

// Import all objects that make up a PrivacyManagement module.
import App from './app.js';

import Components from './components.js';
import Reducer from './reducer.js';
import Config from './config/config.js';

// Init the app.
App.init();

/**
 * <pre>
 * PrivacyManagement public interface.
 *
 * All interactions between different app modules should only happen via this interface, so only export
 * components, methods etc. that you intend to be public.
 *
 * Allows us to more clearly define and document how an app module should behave.
 * </pre>
 *
 * @type {Object}
 * @property {Object} Components React components that this app renders.
 * @property {Object} Reducer Reducer that modify this modules state.
 * @property {Object} Config Configuration for this app module.
 */
const Interface = {
  Components: Components,
  Reducer:    Reducer.rootReducer,
  Config:     Config
};

export default Interface;